export var DictOrdersExtended = [
  /*
  {
    ID: 46,
    label: "Annonciades",
    order: "Order of the Annunciation of the Blessed Virgin Mary",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: "OVM",
    concepts_list_integration: null,
    label_latin: "Ordo de Annuntiatione Beatae Mariae Virginis",
    label_czech: null,
    rule: "Saint Joan of Valois",
    male: 0.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1501.0,
    "foundation ante quem": 1502.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_the_Annunciation_of_the_Blessed_Virgin_Mary",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_l%27Annonciation_de_la_Vierge_Marie",
    image: null,
    note: null,
  },
  */
  {
    ID: 24,
    label: "Antonines",
    order: "Antonines",
    branch: null,
    "order group": "canons (various)",
    category: "canons",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Canonici Regulares Sancti Antonii",
    label_czech: "antonité",
    rule: "Saint Augustine",
    male: 1.0,
    female: null,
    "third order": null,
    "foundation post quem": 1090.0,
    "foundation ante quem": 1100.0,
    "dissolution post quem": 1803.0,
    "dissolution ante quem": 1803.0,
    "alternative names both genders": "antonins",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Hospital_Brothers_of_St._Anthony",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_hospitalier_de_Saint-Antoine",
    image: "1777 merged with Hospitallers, 1803 disappears totally.",
    note: null,
  },
  {
    ID: 47,
    label: "Augustinian Canons",
    order: "Augustinian Canons Regular",
    branch: null,
    "order group": "canons (various)",
    category: "canons",
    abbreviation: "CRSA",
    concepts_list_integration: "C0160",
    label_latin: "Canonici Regulares Sancti Augustini",
    label_czech: "augustiniáni kanovníci",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 800.0,
    "foundation ante quem": 1059.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "augustins, augustinians",
    "alternative names male ": "canons regular, chanoines reguliers",
    "alternative names female": "canonesses regular",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Canons_regular",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Chanoine_r%C3%A9gulier",
    image: null,
    note: null,
  },
  {
    ID: 34,
    label: "Augustinian Friars",
    order: "Augustinian Friars",
    branch: null,
    "order group": "Augustinians",
    category: "mendicant",
    abbreviation: "OSA",
    concepts_list_integration: "C0151",
    label_latin: "Ordo sancti Augustini",
    label_czech: "augustiniáni",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1254.0,
    "foundation ante quem": 1254.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders":
      "augustins, augustinians, augustinian hermits, austin friars",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_Saint_Augustine",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 35,
    label: "Augustinian Recollects",
    order: "Augustinian Friars",
    branch: "Recollects",
    "order group": "Augustinians",
    category: "mendicant",
    abbreviation: "OAR",
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1589.0,
    "foundation ante quem": 1589.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_Augustinian_Recollects",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 50,
    label: "Barnabites",
    order: "Clerics Regular of Saint Paul",
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CRSP",
    concepts_list_integration: null,
    label_latin: "Clerici regulares S. Pauli (Decollati)",
    label_czech: "barnabité",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 51,
    label: "Bartholomites",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Bartholomitae",
    label_czech: "bartolomité",
    rule: "Bartholomites rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 52,
    label: "Basilians",
    order: "Order of Saint Basil the Great",
    branch: null,
    "order group": null,
    category: "monastic",
    abbreviation: "OSBM",
    concepts_list_integration: null,
    label_latin: "Ordo Sancti Basilii Magni",
    label_czech: "basiliáni",
    rule: "Saint Basil",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 3,
    label: "Benedictines",
    order: "Benedictines",
    branch: null,
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: "OSB",
    concepts_list_integration: "C0159",
    label_latin: "Ordo Sancti Benedicti",
    label_czech: "benediktini",
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 529.0,
    "foundation ante quem": 543.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "benedictine",
    "alternative names male ": "bénédictins",
    "alternative names female": "bénédictines",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Benedictines",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Saint-Beno%C3%AEt",
    image: null,
    note: null,
  },
  {
    ID: 65,
    label: "Brothers Hospitallers of St. John of God",
    order: null,
    branch: null,
    "order group": null,
    category: "mendicant",
    abbreviation: "OH",
    concepts_list_integration: null,
    label_latin: "Ordo Hospitalarius S. Ioannis de Deo",
    label_czech: "milosrdní bratři",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 57,
    label: "Calasantins",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "COp",
    concepts_list_integration: null,
    label_latin: "Congregatio pro operaiis christianis a S. Iosepho Calasantio",
    label_czech: "kalasantini",
    rule: "Calasantin rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 5,
    label: "Camaldolese",
    order: "Camaldolese",
    branch: "Camaldolese",
    "order group": "hermits (various)",
    category: "monastic/eremitic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo Camaldulensium",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1012.0,
    "foundation ante quem": 1012.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "camalduls, camaldules",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Camaldolese",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_camaldule",
    image: null,
    note: null,
  },
  {
    ID: 61,
    label: "Canons Regular of the Holy Sepulchre",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Fratres cruciferi",
    label_czech: "křižovníci s červeným křížem",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 62,
    label: "Canons Regular of the Penitence of the Blessed Martyrs",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Fratres Crucigeri cum rubeo corde",
    label_czech: "cyriaci",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 31,
    label: "Capuchins",
    order: "Franciscans",
    branch: "Capuchins",
    "order group": "Franciscans",
    category: "mendicant",
    abbreviation: "OFMCap",
    concepts_list_integration: null,
    label_latin: "Ordo Fratrum Minorum Capuccinorum",
    label_czech: "kapucíni",
    rule: "Saint Francis",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1525.0,
    "foundation ante quem": 1525.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "friars minor capuchin",
    "alternative names male ": "capucins",
    "alternative names female": "capucines",
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_Friars_Minor_Capuchin",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Fr%C3%A8res_mineurs_capucins",
    image: null,
    note: null,
  },
  {
    ID: 33,
    label: "Carmelites",
    order: "Carmelites",
    branch: null,
    "order group": "mendicants (various)",
    category: "mendicant",
    abbreviation: "OCarm",
    concepts_list_integration: "C0149",
    label_latin: "Ordo Fratrum Beatissimæ Virginis Mariæ de Monte Carmelo",
    label_czech: "karmelitáni",
    rule: "Saint Albert",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1206.0,
    "foundation ante quem": 1214.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "carmélites, carmes",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Carmelites",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_du_Carmel",
    image: null,
    note: null,
  },
  {
    ID: 12,
    label: "Carthusians",
    order: "Carthusians",
    branch: null,
    "order group": "Carthusians",
    category: "monastic/eremitic",
    abbreviation: "OCart",
    concepts_list_integration: "C0162",
    label_latin: "Ordo Cartusiensis",
    label_czech: "kartuziáni",
    rule: "Carthusian Statutes",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1084.0,
    "foundation ante quem": 1084.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "chartreux, certosini",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Carthusians",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 10,
    label: "Celestines",
    order: "Benedictines",
    branch: "Celestines",
    "order group": "Benedictines",
    category: "monastic/eremitic",
    abbreviation: "OSBCel",
    concepts_list_integration: null,
    label_latin: "Ordo Celestinorum",
    label_czech: "celestini",
    rule: "Saint Benedict",
    male: 1.0,
    female: 0.0,
    "third order": 0.0,
    "foundation post quem": 1248.0,
    "foundation ante quem": 1248.0,
    "dissolution post quem": 1778.0,
    "dissolution ante quem": 1778.0,
    "alternative names both genders": "célestins, celestini, Cölestiner",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Celestines",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_des_C%C3%A9lestins",
    image: null,
    note: null,
  },
  {
    ID: 1,
    label: "Celtic and Anglo-Saxon",
    order: "Celtic and Anglo-Saxon",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "various",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 8,
    label: "Chalais Order",
    order: "Benedictines",
    branch: "Chalais Order",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: null,
    "third order": 0.0,
    "foundation post quem": 1101.0,
    "foundation ante quem": 1101.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "chalaisienne, chalaisien",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_monastique_de_Chalais",
    image: null,
    note: null,
  },
  {
    ID: 84,
    label: "Christian Brothers",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "FSC",
    concepts_list_integration: null,
    label_latin: "Congregatio Fratrum Scholarum Christianarum",
    label_czech: "školští bratři",
    rule: "Christian Brothers rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 77,
    label: "Christian Knights",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo Militiae Christianae",
    label_czech: "Řád křesťanského rytířstva",
    rule: "St. Francis of Assisi",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 15,
    label: "Cistercians",
    order: "Cistercians",
    branch: null,
    "order group": "Cistercians",
    category: "monastic",
    abbreviation: "OCist",
    concepts_list_integration: "C0150",
    label_latin: "Ordo Cisterciensium",
    label_czech: "cisterciáci",
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1098.0,
    "foundation ante quem": 1098.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": "cisterciens",
    "alternative names female": "cisterciennes",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Cistercians",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_cistercien",
    image: null,
    note: null,
  },
  {
    ID: 58,
    label: "Claretians",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CMF",
    concepts_list_integration: null,
    label_latin: "Congregatio Missionariorum Filiorum",
    label_czech: "klaretini",
    rule: "Claretian rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 4,
    label: "Cluniac Benedictines",
    order: "Benedictines",
    branch: "Cluniacs",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: "OSBClun",
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 909.0,
    "foundation ante quem": 910.0,
    "dissolution post quem": 1790.0,
    "dissolution ante quem": 1790.0,
    "alternative names both genders": "cluniac",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Cluniac_Reforms",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_de_Cluny",
    image: null,
    note: null,
  },
  {
    ID: 30,
    label: "Colletines",
    order: "Poor Clares",
    branch: "Collettines",
    "order group": "Franciscans",
    category: "mendicant",
    abbreviation: "PCC",
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Clare",
    male: 1.0,
    female: 1.0,
    "third order": null,
    "foundation post quem": 1410.0,
    "foundation ante quem": 1410.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": "Coletans",
    "alternative names female": "colletines",
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 43,
    label: "Columbanus monks",
    order: "Columbanus monks",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Columbanus",
    male: 1.0,
    female: null,
    "third order": null,
    "foundation post quem": 591.0,
    "foundation ante quem": 610.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Columbanus#Rule_of_Saint_Columbanus",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/R%C3%A8gle_de_saint_Colomban",
    image: null,
    note: null,
  },
  /*
  {
    ID: 42,
    label: "Conceptionists",
    order: "Conceptionists",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: "OIC",
    concepts_list_integration: null,
    label_latin: "Ordo Inmaculatae Conceptionis",
    label_czech: null,
    rule: "St Clare",
    male: 0.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1489.0,
    "foundation ante quem": 1489.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Conceptionists",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_l%27Immacul%C3%A9e_Conception",
    image: null,
    note: null,
  },
  */
  {
    ID: 60,
    label: "Congregation of St. Michael the Archangel ",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CSMA",
    concepts_list_integration: null,
    label_latin: "Congregatio Sancti Michaelis Archangeli",
    label_czech: "Kongregace sv. Michaela Archanděla",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 66,
    label: "Conventual Franciscans",
    order: null,
    branch: null,
    "order group": null,
    category: "mendicant",
    abbreviation: "OFMConv",
    concepts_list_integration: null,
    label_latin: "Ordo Fratrum Minorum Conventualium",
    label_czech: "minorité",
    rule: "Saint Francis",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 48,
    label: "Crosiers",
    order: "Canons Regular of Holy Cross",
    branch: null,
    "order group": "canons (various)",
    category: "canons",
    abbreviation: "OSC",
    concepts_list_integration: null,
    label_latin: "Fratres sancti crucis",
    label_czech: null,
    rule: "Saint Augustine",
    male: 1.0,
    female: 0.0,
    "third order": 0.0,
    "foundation post quem": 1191.0,
    "foundation ante quem": 1210.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders":
      "crutched friars, brothers of the holy cross, fratres cruciferi, chanoines reguliers de la Sainte-Croix",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Canons_Regular_of_the_Order_of_the_Holy_Cross",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Chanoines_r%C3%A9guliers_de_la_Sainte-Croix",
    image: null,
    note: null,
  },
  {
    ID: 36,
    label: "Discalced Augustinians",
    order: "Augustinian Friars",
    branch: "Discalced",
    "order group": "Augustinians",
    category: "mendicant",
    abbreviation: "OAD",
    concepts_list_integration: null,
    label_latin: "Ordo Augustiniensium Discalceatorum",
    label_czech: "bosí augustiniáni",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1592.0,
    "foundation ante quem": 1592.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Discalced_Augustinians",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 49,
    label: "Discalced Carmelites",
    order: "Carmelites",
    branch: "Discalced",
    "order group": "mendicants (various)",
    category: "mendicant",
    abbreviation: "OCD",
    concepts_list_integration: null,
    label_latin: "Ordo Carmelitarum Discalceatorum",
    label_czech: "bosí karmelitáni",
    rule: "Rule of Saint Albert",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1591.0,
    "foundation ante quem": 1591.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "Carmes déchaux",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Discalced_Carmelites",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/w/index.php?title=Ordre_des_Carmes_d%C3%A9chaux",
    image: null,
    note: null,
  },
  {
    ID: 88,
    label: "Divine Word Missionaries",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SVD",
    concepts_list_integration: null,
    label_latin: "Societas Verbi Domini",
    label_czech: "verbisté",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 27,
    label: "Dominicans",
    order: "Dominicans",
    branch: null,
    "order group": "Dominicans",
    category: "mendicant",
    abbreviation: "OP",
    concepts_list_integration: "C0059",
    label_latin: "Ordo Praedicatorum",
    label_czech: "dominikáni",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1216.0,
    "foundation ante quem": 1216.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "dominican, jacobins, jacobin\n",
    "alternative names male ": "dominicains",
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Dominican_Order",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 2,
    label: "early medieval",
    order: "early medieval",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "various",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 350.0,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 16,
    label: "Feuillants",
    order: "Cistercians",
    branch: "Feuillants",
    "order group": "Cistercians",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Folietani",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1577.0,
    "foundation ante quem": 1577.0,
    "dissolution post quem": 1791.0,
    "dissolution ante quem": 1791.0,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Congregation_of_the_Feuillants",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Feuillants",
    image: null,
    note: null,
  },
  {
    ID: 9,
    label: "Fontevraud Order",
    order: "Benedictines",
    branch: "Fontevraud Order",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1101.0,
    "foundation ante quem": 1101.0,
    "dissolution post quem": 1790.0,
    "dissolution ante quem": 1790.0,
    "alternative names both genders": "Fontevraud, Fontevrault",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_de_Fontevraud",
    image: null,
    note: null,
  },
  {
    ID: 28,
    label: "Franciscans",
    order: "Franciscans",
    branch: null,
    "order group": "Franciscans",
    category: "mendicant",
    abbreviation: "OFM",
    concepts_list_integration: "C0140",
    label_latin: "Ordo Fratrum Minorum",
    label_czech: "františkáni",
    rule: "Saint Francis",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1209.0,
    "foundation ante quem": 1209.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "mineurs",
    "alternative names male ": "franciscains",
    "alternative names female": "franciscaines, clarisses",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Franciscans",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 85,
    label: "Fratres Consolati",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CFC",
    concepts_list_integration: null,
    label_latin: "Congregatio Fratrum Consolatorum de Gethsemani",
    label_czech: "těšitelé",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 11,
    label: "Grandmontines",
    order: "Grandmontines",
    branch: null,
    "order group": "hermits (various)",
    category: "monastic/eremitic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Rule of Grandmont",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1076.0,
    "foundation ante quem": 1076.0,
    "dissolution post quem": 1772.0,
    "dissolution ante quem": 1772.0,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Grandmontines",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_de_Grandmont",
    image: null,
    note: null,
  },
  {
    ID: 25,
    label: "Hermits of St. William",
    order: "Hermits of St. William",
    branch: null,
    "order group": "hermits (various)",
    category: "monastic/eremitic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Augustine #Saint Benedict",
    male: 1.0,
    female: 0.0,
    "third order": 0.0,
    "foundation post quem": 1157.0,
    "foundation ante quem": 1157.0,
    "dissolution post quem": 1847.0,
    "dissolution ante quem": 1847.0,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Hermits_of_Saint_William",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Saint-Guillaume",
    image: null,
    note: null,
  },
  {
    ID: 40,
    label: "Hieronymites",
    order: "Hieronymites",
    branch: null,
    "order group": "Augustinians",
    category: "monastic/eremitic",
    abbreviation: "OSH",
    concepts_list_integration: null,
    label_latin: "Ordo Sancti Hieronymi",
    label_czech: null,
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1373.0,
    "foundation ante quem": 1373.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Hieronymites",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Saint-J%C3%A9r%C3%B4me",
    image: null,
    note: null,
  },
  {
    ID: 18,
    label: "Hospitallers",
    order: "Hospitallers",
    branch: null,
    "order group": "military orders",
    category: "military",
    abbreviation: "OSIH",
    concepts_list_integration: null,
    label_latin: "Ordo Fratrum Hospitalis Sancti Ioannis Hierosolymitani",
    label_czech: "johanité",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1099.0,
    "foundation ante quem": 1099.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "hospitallers, knights hospitalier",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Knights_Hospitaller",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Saint-Jean_de_J%C3%A9rusalem",
    image: null,
    note: null,
  },
  {
    ID: 21,
    label: "Hospitallers of the Holy Spirit",
    order: "Hospitallers of the Holy Spirit",
    branch: null,
    "order group": "canons (various)",
    category: "canons",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo sancti Spiritus",
    label_czech: null,
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1170.0,
    "foundation ante quem": 1190.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_the_Holy_Ghost",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_des_Hospitaliers_du_Saint-Esprit",
    image: null,
    note: null,
  },
  {
    ID: 32,
    label: "Humiliati",
    order: "Humiliati",
    branch: null,
    "order group": "mendicants (various)",
    category: "mendicant",
    abbreviation: "OHumil",
    concepts_list_integration: "C0157",
    label_latin: "Ordo Humiliatorum",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1130.0,
    "foundation ante quem": 1150.0,
    "dissolution post quem": 1571.0,
    "dissolution ante quem": 1571.0,
    "alternative names both genders": null,
    "alternative names male ": "humiliés, umiliati",
    "alternative names female": "umiliate",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Humiliati",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_des_humili%C3%A9s",
    image: null,
    note: null,
  },
  {
    ID: 54,
    label: "Hyberns",
    order: null,
    branch: null,
    "order group": null,
    category: "mendicant",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin:
      "Ordo Fratrum Minorum Strictioris Observantiae Provinciae Hiberniae",
    label_czech: "hyberni",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 55,
    label: "Ivanites",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Congregatio Fratrum Eremitarum Divi Ivani",
    label_czech: "ivanité",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 56,
    label: "Jesuits",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SJ",
    concepts_list_integration: null,
    label_latin: "Societas Jezu",
    label_czech: "jezuité",
    rule: "Jesuit rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 76,
    label: "Knights of the Cross with the Red Star",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: "OCr",
    concepts_list_integration: null,
    label_latin: "Crucigeri cum rubea stella",
    label_czech: "křižovníci s červenou hvězdou",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 7,
    label: "La Chaise-Dieu Benedictines",
    order: "Benedictines",
    branch: "La Chaise-Dieu",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: null,
    "third order": 0.0,
    "foundation post quem": 1043.0,
    "foundation ante quem": 1043.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "casadéens, casadéen",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Abbaye_de_la_Chaise-Dieu",
    image: null,
    note: null,
  },
  {
    ID: 80,
    label: "La Salette Missionaries",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "MS",
    concepts_list_integration: null,
    label_latin: "Missionarii Dominae Nostrae a La Salette",
    label_czech: "saletini",
    rule: "rule of La Salette Missionaries",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 71,
    label: "Lazarists (Vincentians)",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CM",
    concepts_list_integration: null,
    label_latin: "Congregatio Missionis",
    label_czech: "lazaristé",
    rule: "Lazarist rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 63,
    label: "Marian Fathers",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "MIC",
    concepts_list_integration: null,
    label_latin:
      "Congregatio Clericorum Regularium Marianorum Immaculate Conceptions B. Mariae Virginis",
    label_czech: "mariáni",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 64,
    label: "Marianists",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SM",
    concepts_list_integration: null,
    label_latin: "Societas Mariae",
    label_czech: "marianisté",
    rule: "Marianists rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 37,
    label: "Mercedarians",
    order: "Mercedarians",
    branch: null,
    "order group": "Augustinians",
    category: "mendicant",
    abbreviation: "OMerc",
    concepts_list_integration: null,
    label_latin: "Ordo Beatae Mariae de Mercede Redemptionis Captivorum",
    label_czech: null,
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1218.0,
    "foundation ante quem": 1218.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_the_Blessed_Virgin_Mary_of_Mercy",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Notre-Dame-de-la-Merci",
    image: null,
    note: null,
  },
  {
    ID: 41,
    label: "Minims",
    order: "Minims",
    branch: null,
    "order group": "other",
    category: "mendicant",
    abbreviation: "OM",
    concepts_list_integration: null,
    label_latin: "Ordo Minimorum",
    label_czech: "pauláni",
    rule: "Saint Francis of Paola",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1436.0,
    "foundation ante quem": 1474.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "minimes",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Minim_(religious_order)",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_des_Minimes",
    image: null,
    note: null,
  },
  {
    ID: 67,
    label: "Oblates",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "OMI",
    concepts_list_integration: null,
    label_latin:
      "Congregatio Missionariorum Oblatorum Mariae Virginis Immaculatae",
    label_czech: "obláti",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 14,
    label: "Olivetans",
    order: "Benedictines",
    branch: "Olivetans",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: "OSBOliv",
    concepts_list_integration: null,
    label_latin: "Congregatio Sanctæ Mariæ Montis Oliveti",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1313.0,
    "foundation ante quem": 1313.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "olivétains",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Olivetans",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_du_Mont-Olivet",
    image: null,
    note: null,
  },
  {
    ID: 68,
    label: "Oratorians",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "dO",
    concepts_list_integration: null,
    label_latin: "Congregatio Oratorii S. Mariae di Vallicela",
    label_czech: "oratoriáni",
    rule: "Oratorian rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 22,
    label: "Order of St. Lazarus",
    order: "Order of St. Lazarus",
    branch: null,
    "order group": "military orders",
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo Sancti Lazari in Ierusalem",
    label_czech: "Vojenský a špitální řád rytířů sv. Lazara Jeruzalémského",
    rule: "Saint Augustine",
    male: 1.0,
    female: null,
    "third order": 0.0,
    "foundation post quem": 1119.0,
    "foundation ante quem": 1142.0,
    "dissolution post quem": 1830.0,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Order_of_Saint_Lazarus",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_de_Saint-Lazare_de_J%C3%A9rusalem",
    image: null,
    note: null,
  },
  {
    ID: 83,
    label: "Order of St. Stanislav",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: "OStS",
    concepts_list_integration: null,
    label_latin: "Ordo Sti Stanislai",
    label_czech: "Řád sv. Stanislava",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 78,
    label: "Order of the Holy Spirit",
    order: null,
    branch: null,
    "order group": null,
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo Sancti Spiritus",
    label_czech: "Řád sv. Ducha",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 69,
    label: "Pallottines",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SAC",
    concepts_list_integration: null,
    label_latin: "Societas Apostolatus Catholici",
    label_czech: "pallotini",
    rule: "Pallotines rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 70,
    label: "Passionists",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CP",
    concepts_list_integration: null,
    label_latin: "Congregatio Passionis",
    label_czech: "pasionisté",
    rule: "Saint Paul of the Cross",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 72,
    label: "Pauline Fathers",
    order: null,
    branch: null,
    "order group": null,
    category: "mendicant",
    abbreviation: "OSPPE",
    concepts_list_integration: null,
    label_latin: "Ordo Sancti Pauli Primi Eremitae",
    label_czech: "pavlíni",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 73,
    label: "Petrins",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CSSS",
    concepts_list_integration: null,
    label_latin: "Congregatio Sanctissimi Sacramenti",
    label_czech: "petrini",
    rule: "Saint Benedict",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 74,
    label: "Piarists",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "OSchP",
    concepts_list_integration: null,
    label_latin: "Ordo PP. Piarum Scholarum",
    label_czech: "piaristé",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  /*
  {
    ID: 29,
    label: "Poor Clares",
    order: "Poor Clares",
    branch: null,
    "order group": "Franciscans",
    category: "mendicant",
    abbreviation: "OSC",
    concepts_list_integration: null,
    label_latin: "Ordo sanctae Clarae",
    label_czech: null,
    rule: "Saint Clare",
    male: 0.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1212.0,
    "foundation ante quem": 1212.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": "clarisses",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Poor_Clares",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_des_Pauvres_Dames",
    image: null,
    note: null,
  },
  */
  {
    ID: 23,
    label: "Praemonstratensians",
    order: "Praemonstratensians",
    branch: null,
    "order group": "canons (various)",
    category: "canons",
    abbreviation: "OPraem",
    concepts_list_integration: "C0158",
    label_latin: "Ordo Praemonstratensis",
    label_czech: "premonstráti",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1120.0,
    "foundation ante quem": 1120.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "prémontrés, norbertines",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Premonstratensians",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 59,
    label: "Priests of the Sacred Heart of Jesus",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SCI",
    concepts_list_integration: null,
    label_latin: "Congregatio Missionariorum SS. Cordis Jesu",
    label_czech: "Kongregace Misionářů Nejsvětějšího Srdce Ježíšova",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 75,
    label: "Redemptorists ",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CSSR",
    concepts_list_integration: null,
    label_latin: "Congregatio Sanctissimi Redemptoris",
    label_czech: "redemptoristé",
    rule: "Redemptoris rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 53,
    label: "Sacramentinos",
    order: "Congregation of the Blessed Sacrament",
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SSS",
    concepts_list_integration: null,
    label_latin: "Societas Sanctissimi Sacramenti",
    label_czech: "eucharistini",
    rule: "Sacramention rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 82,
    label: "Sacred Heart Society",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: "Společnost Nejsvětějšího Srdce Ježíšova",
    rule: "Saint Ignatius of Loyola",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 79,
    label: "Salesians",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SDB",
    concepts_list_integration: null,
    label_latin: "Societas Don Bosco",
    label_czech: "salesiáni",
    rule: "Salesian rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 81,
    label: "Salvatorians",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "SDS",
    concepts_list_integration: null,
    label_latin: "Societas Divini Salvatoris",
    label_czech: "salvatoriáni",
    rule: "Salvatorian rule",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 45,
    label: "Savigniac Order",
    order: "Savigniac Order",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: null,
    "third order": 0.0,
    "foundation post quem": 1112.0,
    "foundation ante quem": 1112.0,
    "dissolution post quem": 1147.0,
    "dissolution ante quem": 1147.0,
    "alternative names both genders": "savigniens",
    "alternative names male ": "savigniens",
    "alternative names female": "savigniennes",
    "Wikipedia entry en":
      "https://en.wikipedia.org/wiki/Congregation_of_Savigny",
    "Wikipedia entry fr": null,
    image: "Merged with Cistercians in 1147.",
    note: null,
  },
  {
    ID: 38,
    label: "Servites",
    order: "Servites",
    branch: null,
    "order group": "Augustinians",
    category: "mendicant",
    abbreviation: "OSM",
    concepts_list_integration: "C0152",
    label_latin: "Ordo Servorum Beatae Virginis Mariae",
    label_czech: "servité",
    rule: "Saint Augustine",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1233.0,
    "foundation ante quem": 1233.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Servite_Order",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  /*
  {
    ID: 39,
    label: "Sisters of Saint Andrew",
    order: "Sisters of Saint Andrew",
    branch: null,
    "order group": "Augustinians",
    category: "hospitaller",
    abbreviation: "RSA",
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Saint Augustine",
    male: 0.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1231.0,
    "foundation ante quem": 1249.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Religieuses_de_Saint-Andr%C3%A9",
    image: null,
    note: null,
  },
  */
  {
    ID: 13,
    label: "Sylvestrines",
    order: "Benedictines",
    branch: "Sylvestrines",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: "OSBSilv",
    concepts_list_integration: null,
    label_latin: "Congregatio Silvestrina Ordinis Sancti Benedicti",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 0.0,
    "third order": 0.0,
    "foundation post quem": 1231.0,
    "foundation ante quem": 1231.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "silvestrins",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Sylvestrines",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_des_Sylvestrins",
    image: null,
    note: null,
  },
  {
    ID: 19,
    label: "Templars",
    order: "Templars",
    branch: null,
    "order group": "military orders",
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Pauperes commilitones Christi Templique Salomonici",
    label_czech: "templáři",
    rule: "Templar Rule",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1119.0,
    "foundation ante quem": 1119.0,
    "dissolution post quem": 1312.0,
    "dissolution ante quem": 1312.0,
    "alternative names both genders": "templiers",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Knights_Templar",
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 20,
    label: "Teutonic Knights",
    order: "Teutonic Knights",
    branch: null,
    "order group": "military orders",
    category: "military",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: "Ordo Domus Sanctæ Mariæ Teutonicorum",
    label_czech: "němečtí rytíři",
    rule: "Saint Augustine",
    male: 1.0,
    female: null,
    "third order": 0.0,
    "foundation post quem": 1190.0,
    "foundation ante quem": 1190.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders":
      "teutonique, deutscher ritterorden, deutschritter-orden",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Teutonic_Order",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_Teutonique",
    image: null,
    note: null,
  },
  {
    ID: 86,
    label: "Theatines",
    order: null,
    branch: null,
    "order group": null,
    category: null,
    abbreviation: "CR",
    concepts_list_integration: null,
    label_latin: "Ordo Clericorum Regularium vulgo Theatinorum",
    label_czech: "theatini",
    rule: "Saint Augustine",
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 17,
    label: "Trappists",
    order: "Cistercians",
    branch: "Trappists",
    "order group": "Cistercians",
    category: "monastic",
    abbreviation: "OCSO",
    concepts_list_integration: null,
    label_latin: "Ordo Cisterciensium Strictioris Observantiae",
    label_czech: "trapisté",
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1664.0,
    "foundation ante quem": 1664.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": "trappistes",
    "alternative names female": "trappistines",
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Trappists",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Ordre_cistercien_de_la_Stricte_Observance",
    image: null,
    note: null,
  },
  {
    ID: 26,
    label: "Trinitarians",
    order: "Trinitarians",
    branch: null,
    "order group": "mendicants (various)",
    category: "mendicant",
    abbreviation: "OSST",
    concepts_list_integration: null,
    label_latin: "Ordo Sanctissimae Trinitatis et captivorum",
    label_czech: "trinitáři",
    rule: "Trinitarian Rule",
    male: 1.0,
    female: 1.0,
    "third order": 1.0,
    "foundation post quem": 1198.0,
    "foundation ante quem": 1198.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": "trinitaires",
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Trinitarian_Order",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_des_Trinitaires",
    image: null,
    note: null,
  },
  {
    ID: 87,
    label: "Trinitarians",
    order: null,
    branch: null,
    "order group": null,
    category: "mendicant",
    abbreviation: "OSST",
    concepts_list_integration: null,
    label_latin: "Ordo Sanctissime Trinitatis redemptionis capticorum",
    label_czech: "trinitáři",
    rule: null,
    male: null,
    female: null,
    "third order": null,
    "foundation post quem": null,
    "foundation ante quem": null,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": null,
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": null,
    "Wikipedia entry fr": null,
    image: null,
    note: null,
  },
  {
    ID: 44,
    label: "Valliscaulians",
    order: "Valliscaulians",
    branch: null,
    "order group": "other",
    category: "monastic",
    abbreviation: null,
    concepts_list_integration: null,
    label_latin: null,
    label_czech: null,
    rule: "Valliscaulian Rule",
    male: 1.0,
    female: null,
    "third order": null,
    "foundation post quem": 1180.0,
    "foundation ante quem": 1205.0,
    "dissolution post quem": 1764.0,
    "dissolution ante quem": 1764.0,
    "alternative names both genders": "valliscauliens",
    "alternative names male ": "valliscauliens",
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Valliscaulian_Order",
    "Wikipedia entry fr":
      "https://fr.wikipedia.org/wiki/Abbaye_du_Val_des_Choues",
    image: null,
    note: null,
  },
  {
    ID: 6,
    label: "Vallombrosians",
    order: "Benedictines",
    branch: "Vallombrosians",
    "order group": "Benedictines",
    category: "monastic",
    abbreviation: "OSBVall",
    concepts_list_integration: null,
    label_latin: "Congregatio Vallis Umbrosae Ordinis Sancti Benedicti",
    label_czech: null,
    rule: "Saint Benedict",
    male: 1.0,
    female: 1.0,
    "third order": 0.0,
    "foundation post quem": 1039.0,
    "foundation ante quem": 1039.0,
    "dissolution post quem": null,
    "dissolution ante quem": null,
    "alternative names both genders": "vallombrosains",
    "alternative names male ": null,
    "alternative names female": null,
    "Wikipedia entry en": "https://en.wikipedia.org/wiki/Vallumbrosan_Order",
    "Wikipedia entry fr": "https://fr.wikipedia.org/wiki/Ordre_de_Vallombreuse",
    image: null,
    note: null,
  },
  { ID: "100", label: "other", alternatives: [] },
  { ID: "0", label: "unknown", alternatives: [""] },
];
